import type { ConsentSignatureRow, ConsentVersionRow, HandbookAckRow, HandbookVersionRow } from '@routeback/core';
import { useLiveQuery } from 'dexie-react-hooks';
import { useApp } from '../../lib/app';
import { gate, pendingFor, type Pending } from './signoff';

/** What this person still has to sign (read from the phone, so it works offline). `undefined` while loading. */
export function useSignoffs(): { pending: Pending; blocked: boolean; remind: boolean } | undefined {
  const app = useApp();
  return useLiveQuery(async () => {
    const t = <T>(name: string) => app.db.table<T, string>(name).where('company_id').equals(app.company.id).toArray();
    const [hb, acks, cv, sigs] = await Promise.all([
      t<HandbookVersionRow>('handbook_versions'), t<HandbookAckRow>('handbook_acks'),
      t<ConsentVersionRow>('consent_versions'), t<ConsentSignatureRow>('consent_signatures'),
    ]);
    const pending = pendingFor(app.userId, hb, acks, cv, sigs);
    return { pending, ...gate(app.role, pending) };
  }, [app.db, app.company.id, app.userId, app.role]);
}
